import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { contentStyles, h3, tag } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/CtaLink/CtaLink.styles';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  flex: 1 2;

  [data-background='green'] & {
    color: ${brand.white};
  }

  ${CtaLinkStyles.Container} {
    margin-top: ${fluid(24, 36)};
  }
`;
const TestimonialWrapper = styled.div `
  will-change: opacity;
  transition: opacity 0.3s ease;
  opacity: 1;
  height: 100%;
  display: grid;
  place-content: center;

  &[data-is-showing='false'] {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }

  > svg {
    color: ${brand.green};
    width: 46px;
    margin-bottom: ${fluid(8, 20)};

    [data-background='green'] & {
      color: ${brand.beige};
    }
  }
`;
const TestimonialTitle = styled.h3 `
  ${h3};

  margin: 0 0 ${fluid(18, 32)};
`;
const Subtitle = styled.p `
  ${tag};

  margin: 0;
`;
const Text = styled.div `
  ${contentStyles};

  p:last-child {
    margin-bottom: 0;
  }
`;
const AccreditationWrapper = styled.div `
  margin: ${fluid(14, 28)} 0 0;
`;
const Title = styled.div `
  ${fonts.brandonGrotesque.regular};

  font-size: ${fluid(16, 20)};
  line-height: ${fluid(20, 24)};
  text-transform: uppercase;
  border-left: ${fluid(2, 4)} solid ${brand.green};
  padding-left: ${fluid(16, 24)};

  [data-background='green'] & {
    border-color: ${brand.beige};
  }
`;
const Name = styled.div `
  ${fonts.zahrah.medium};
  font-size: ${fluid(24, 28)};
  line-height: ${fluid(28, 32)};
  border-left: ${fluid(2, 4)} solid ${brand.green};
  padding-left: ${fluid(16, 24)};

  [data-background='green'] & {
    border-color: ${brand.beige};
  }
`;
const TestimonialStyles = {
    AccreditationWrapper,
    Container,
    Name,
    TestimonialTitle,
    TestimonialWrapper,
    Text,
    Title,
    Subtitle,
};
export default TestimonialStyles;
